import {
  Brand,
  Retailer,
  RetailerAccount,
} from '@promoboxx/graphql-gateway-types'
import { useCallback, useEffect, useMemo, useState } from 'react'
import { useSelector } from 'react-redux'

import { currentRetailerAccountSelector } from '@src/stores/app/selectors'

let previousSelection: (string | number)[] | undefined = undefined

function usePreviouslySelectedBrand(
  defaultValue?: (string | number)[],
  restrict?: string,
) {
  const [previouslySelectedBrand, setPreviouslySelectedBrand] = useState(() => {
    return previousSelection || defaultValue
  })

  const currentRetailerAccount: RetailerAccount = useSelector(
    currentRetailerAccountSelector,
  )

  const setPreviouslySelectedRetailer = useCallback(
    (idsOrSlugs: (string | number)[]) => {
      const foundBrands: Brand[] = []

      for (const idOrSlug of idsOrSlugs || []) {
        for (const retailer of currentRetailerAccount.retailers || []) {
          if (
            retailer.brand &&
            (String(retailer.id) === String(idOrSlug) ||
              String(retailer.slug) === String(idOrSlug))
          ) {
            if (restrict) {
              if (restrict === 'brand' && !retailer.brand?.community) {
                foundBrands.push(retailer.brand)
              } else if (restrict === 'industry' && retailer.brand?.community) {
                foundBrands.push(retailer.brand)
              }
            } else {
              foundBrands.push(retailer.brand)
            }
          }
        }
      }

      setPreviouslySelectedBrand(foundBrands.map((x) => x.id))
    },
    [currentRetailerAccount.retailers, restrict],
  )

  useEffect(() => {
    previousSelection = previouslySelectedBrand
  }, [previouslySelectedBrand])

  const { foundRetailers, foundBrands } = useMemo(() => {
    let foundRetailers: Retailer[] = []
    let foundBrands: Brand[] = []

    if (previouslySelectedBrand) {
      for (const idOrSlug of previouslySelectedBrand) {
        for (const retailer of currentRetailerAccount.retailers || []) {
          if (
            retailer.brand &&
            (String(retailer.brand.id) === String(idOrSlug) ||
              String(retailer.brand.slug) === String(idOrSlug))
          ) {
            if (restrict) {
              if (restrict === 'brand' && !retailer.brand?.community) {
                foundRetailers.push(retailer)
                foundBrands.push(retailer.brand)
              } else if (restrict === 'industry' && retailer.brand?.community) {
                foundRetailers.push(retailer)
                foundBrands.push(retailer.brand)
              }
            } else {
              foundRetailers.push(retailer)
              foundBrands.push(retailer.brand)
            }
          }
        }
      }
    }

    return { foundBrands, foundRetailers }
  }, [currentRetailerAccount.retailers, previouslySelectedBrand, restrict])

  return {
    setPreviouslySelectedRetailer,
    setPreviouslySelectedBrand,
    previouslySelectedRetailers: foundRetailers,
    previouslySelectedBrands: foundBrands,
  }
}

export default usePreviouslySelectedBrand
